var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"78ca6553fdd2783c0dfc4b6e656bff19eaafd527"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-store@docupet"]={id:"78ca6553fdd2783c0dfc4b6e656bff19eaafd527"};
      